<div class="header" id="forShoppers">
  <div class="header-content">
    <img class="m-show" src="/assets/final/logo.png" />
    <h1 class="header-title">
      Shop now, pay in 3 payments.<br /><span>Zero fees, Zero interest.</span
      ><br /><span
        ><small style="font-size: 21px"
          >Shop online or in-store and get your order right away with
          ZeroPay!</small
        ></span
      >
    </h1>
    <br />
    <a mat-stroked-button [href]="redirect" target="_blank">APPLY NOW</a>
  </div>
</div>
<div class="how-it-works" id="howItWorks">
  <div class="content">
    <h1>How it works</h1>
    <br />
    <p>Shop what you want, way easier, with ZeroPay.</p>
    <a mat-stroked-button [href]="redirect" target="_blank" class="btn-action"
      >APPLY NOW</a
    >
    <div fxLayout="row wrap" class="steps">
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <!-- <img src="/assets/final/get-it.png" /> -->
        <img src="/assets/icons/1.png" />
        <h2>get it.</h2>
        <p class="info-paragraph">
          Apply for your ZeroPay account by following the quick and easy steps.
          Be approved in less than a minute.
        </p>
      </div>
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <!-- <img src="/assets/final/got-it.png" /> -->
        <img src="/assets/icons/2.png" />
        <h2>got it.</h2>
        <p class="info-paragraph">
          Select ZeroPay as your preferred secure payment option at any one of
          our shopping partners.
        </p>
      </div>
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <img src="/assets/icons/3.png" />
        <h2>good.</h2>
        <p class="info-paragraph">
          Pay for your shopping in 3 x
          <span> Zero fees, Zero interest</span> payments. Your order is shipped
          right away.
        </p>
      </div>
    </div>
  </div>
</div>
<app-benefits></app-benefits>
<!-- <app-featured-where-to-shop></app-featured-where-to-shop> -->
<div class="join-us-container mat-elevation-z2" id="joinUs">
  <div fxLayout="row wrap">
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="row-container">
      <div class="content" style="text-align: center">
        <h1 class="Join-title">
          Offer your customers a<br /><span>flexible interest free<br /></span
          >payment option.
        </h1>
        <br />
        <p class="info-paragraph">
          In today's fast paced and ever changing retail environment, give your
          customer's a risk free, interest free payment option while increasing
          your sales.
        </p>
        <br />
        <button
          mat-stroked-button
          [routerLink]="['/merchant/signup']"
          (click)="scrollTo('top')"
        >
          JOIN US
        </button>
      </div>
    </div>
    <div
      fxFlex.gt-sm="50"
      fxFlex.lt-sm="0"
      class="join"
      style="background-image: url('/assets/join-us-2.jpg')"
    ></div>
  </div>
</div>
